import { Mark, mergeAttributes } from '@tiptap/core';
import { RICH_TEXT_EXTENSIONS } from 'components/richText';

export const SUGGESTION_MARK_NAME = 'suggestion';
const SUGGESTION_ATTRIBUTE = 'data-suggestion';

export const SuggestionMarkBase = Mark.create({
  name: SUGGESTION_MARK_NAME,
  inclusive: false,
  priority: 110,

  addOptions() {
    return { HTMLAttributes: {} };
  },

  addAttributes() {
    return {
      id: {
        default: '',
        parseHTML: (element: HTMLElement) => element.getAttribute(SUGGESTION_ATTRIBUTE),
        renderHTML: (attributes: { id: string }) => ({ [SUGGESTION_ATTRIBUTE]: attributes.id }),
      },
    };
  },

  parseHTML() {
    return [{ tag: `span[${SUGGESTION_ATTRIBUTE}]` }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
});

export const NOTE_EXTENSIONS = [...RICH_TEXT_EXTENSIONS, SuggestionMarkBase];
